
export default {
  async asyncData ({
    route,
    error,
    redirect,
    $getPosts,
    $postMeta,
    $getRedirection,
  }) {
    const fullPath = route.path;
    const queryParams = {
      fields: `id,title,slug,excerpt,content,image,author,date,time,categories,link,acf,type,nextprev,terms,meta,readingTime`,
      options: {
        taxonomy: `page_type`,
      },
      path: fullPath,
    };

    const request = await $getPosts(`/postpath`, queryParams);
    if (request) {
      return {
        meta: $postMeta(request[0]),
        post: request[0],
      };
    }
    error({
      statusCode: 404,
      message: `This page cannot be found`,
    });
  },
  data () {
    return {
      post: {},
      fixture: null,
    };
  },
  mounted () {
    this.setPostData(this.post);
    this.$nextTick(() => {
      const colourScheme = this.post?.acf?.use_commercial_colour_scheme;
      this.$store.dispatch(`wp/setColourScheme`, colourScheme);
    });
  },
  head () {
    return {
      title: `${process.env.siteTitle} - ${this.post.title}`,
      description: this.post.yoast ? this.post.yoast.description : this.post.excerpt,
      meta: this.meta,
      link: [
        {
          rel: `canonical`,
          href: `${process.env.desiredCanonical}${this.$route.path}`,
        },
      ],
    };
  },
};
